
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import formatPriceRP from "@/app/infrastructures/misc/common-library/v2/FormatPriceRP";
import formatByCountry from "@/app/infrastructures/misc/common-library/FormatByCountry";
import { Options, prop, Vue } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";
import { AccountController } from "@/app/ui/controllers/AccountController";

class Props {
  summary = prop<any>({
    required: true
  });
}

@Options({
  components: {
    OverlayPanel
  }
})
export default class DetailItems extends Vue.with(Props) {
  private isCollapsed = false;

  get accountCurrency(): "IDR" | "MYR" {
    return (
      (AccountController.accountData?.accountCurrency as "IDR" | "MYR") ?? "IDR"
    );
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
  formatDateTime(date: any): string {
    return formatDate(date);
  }

  formatPriceNumber(price: number) {
    return price ? formatPriceRP(price, this.accountCurrency) : "-";
  }

  formatWeight(weight: number | null | undefined): string {
    if (weight == null || isNaN(Number(weight))) return "-";
    const formatted = formatByCountry(Number(weight), { type: "weight" });
    return `${formatted} kg`;
  }

  formatDimension(
    length: number | null | undefined,
    width: number | null | undefined,
    height: number | null | undefined
  ): string {
    if (length == null && width == null && height == null) return "-";

    const l = formatByCountry(Number(length ?? 0), { type: "dimension" });
    const w = formatByCountry(Number(width ?? 0), { type: "dimension" });
    const h = formatByCountry(Number(height ?? 0), { type: "dimension" });

    // Preserve existing joiner: ' x '
    return `${l} x ${w} x ${h} cm`;
  }

  formatQuantity(quantity: number | null | undefined): string {
    if (quantity == null || isNaN(Number(quantity))) return "-";
    return formatByCountry(Number(quantity), { type: "quantity" });
  }

  toggleTooltip(event: any) {
    const refs: any = this.$refs;
    refs["commodityName"].toggle(event);
  }
}
